import C from "@/modules/user/ImpersonateTopItem.module.css";

import { WButton } from "@/components/button/WButton.tsx";
import { stopImpersonatingAction } from "@/modules/user/impersonation.action.ts";
import { impersonationAtom } from "@/modules/user/impersonation.store.ts";
import { cn } from "@/utils/classNames.ts";
import { Trans } from "@lingui/react/macro";
import { useAtomValue, useSetAtom } from "jotai/react";

export default function ImpersonateTopItem({ isMobile }: { isMobile?: boolean }) {
    const impersonation = useAtomValue(impersonationAtom);
    const stopImpersonating = useSetAtom(stopImpersonatingAction);

    if (!impersonation) {
        return null;
    }

    return (
        <div className={cn(C.Holder, isMobile ? C.Mobile : C.Desktop)}>
            <span>
                <Trans>
                    Acting as <b>{impersonation.access_owner}</b>
                </Trans>
            </span>
            <WButton className={C.Button} color="success" variant="basic" size="xs" action={stopImpersonating}>
                <Trans>Back to your account</Trans>
            </WButton>
        </div>
    );
}
